<template>
  <div>
    <NovelHeader />
    <router-view />
  </div>
</template>

<script>
import NovelHeader from '../components/Header'

export default {
  components: { NovelHeader }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?f6dc7bec